const chartjs = require('../../../../../../components/chart/chartjs')
const { changeSVG } = require('../../../../../../js-handler/graphic')
let barSimpleChart = null;

export function createChart(parameter) {
	let canvas = document.getElementById('chartBarCustomerProfit');
	if (!canvas) return;

	// --- SOLUCIÓN: Limpiar el canvas manualmente ---
	const parent = canvas.parentNode;
	const newCanvas = canvas.cloneNode(false); // Clona el canvas sin eventos ni contenido
	parent.replaceChild(newCanvas, canvas);
	canvas = newCanvas;
	// -----------------------

	const datetimeSpan = document.getElementById('datetimeSpanCustomerProfit');
	const companyName = document.getElementById('companyNameCustomerProfit');

	companyName.textContent = parameter[0].company_name;
	datetimeSpan.textContent = parameter[0].current_dateTime;

	let last_month = 0;
	let last_6_months = 0;
	let last_year = 0;

	parameter.forEach(row => {
		last_month += parseFloat((row.total_last_month || '0').replace(/[^0-9.-]+/g, "")) || 0;
		last_6_months += parseFloat((row.total_last_6_months || '0').replace(/[^0-9.-]+/g, "")) || 0;
		last_year += parseFloat((row.total_last_year || '0').replace(/[^0-9.-]+/g, "")) || 0;
	});

	const total = last_month + last_6_months + last_year;

	const chartData = {
		labels: ['Last Months', 'Last 6 Month', 'Last Year', 'Total'],
		dataset: [{
			label: 'Profit',
			backgroundColor: ['#36a2eb', '#4bc0c0', '#ffcd56', '#f86624'],
			data: [last_month, last_6_months, last_year, total],
		}]
	};

	barSimpleChart = chartjs.start({
		elem: 'bar',
		act: 'createMultipleLineWithLabels',
		targetChart: { html: canvas },
		data: chartData,
		options: {
			aspectRatio: 10 / 5,
			legend: false
		}
	});
}